
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/ChartCodeRender/index.md?watch=parent';
    export const demoIndex = {
  ids: ["chartcoderender-demo-common","chartcoderender-demo-default","chartcoderender-demo-internationalization","chartcoderender-demo-stream","chartcoderender-demo-errorrender","chartcoderender-demo-extra"],
  getter: () => import(/* webpackChunkName: "meta__ChartCodeRender__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/ChartCodeRender/index.md?type=demo')
};